const PasswordDots = () => {
  return <div className="flex items-center gap-1" data-sentry-component="PasswordDots" data-sentry-source-file="PasswordDots.jsx">
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
      <span className="mx-px inline-block size-1 rounded-md bg-black" />
    </div>;
};
export default PasswordDots;